import script from "./accountInfoAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./accountInfoAlert.vue?vue&type=script&setup=true&lang=js"

import "./accountInfoAlert.vue?vue&type=style&index=0&id=29760137&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29760137"]])

export default __exports__